import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../config/webpack/loaders/svg-sprite/sprite-runtime-with-turbolinks.js";
var symbol = new SpriteSymbol({
  "id": "icon__arrow-down",
  "use": "icon__arrow-down-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon__arrow-down\"><path d=\"M12.335 23.879a.994.994 0 0 1-1.082-.214h-.001l-5.964-5.978a.994.994 0 0 1 0-1.409.993.993 0 0 1 1.406 0l4.267 4.277V1.043a.994.994 0 0 1 1.987 0v19.512l4.267-4.277a.993.993 0 0 1 1.406 0 .998.998 0 0 1 0 1.409l-5.964 5.978h-.001a.971.971 0 0 1-.321.214z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol